const SAFE_RETURN_STATUS = {
  PENDING: "PENDING",
  ACTION_TAKEN: "ACTION_TAKEN",
};

export default SAFE_RETURN_STATUS;
